// store para guardar la cantidad de decimales y este disponible para toda la app

export default {
    namespaced: true,   // para usar en el store de vuex
    state: {
        numberDecimals: 2
    },
    getters: {
        getNumberDecimals(state) {
            return state.numberDecimals
        }
    },
    mutations: {
        setNumberDecimals(state, numberDecimals) {
            state.numberDecimals = numberDecimals
        }
    },
    actions: {
        setNumberDecimals({ commit }, numberDecimals) {
            commit('setNumberDecimals', numberDecimals)
        }
    }
}
